"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.longStatusMessages = exports.shortStatusMessages = void 0;
const committeeOpinion_1 = require("../../forms/ktx/committeeOpinion");
exports.shortStatusMessages = {
    [committeeOpinion_1.Status.NEW]: {
        id: "ktx.patient_status.short.new",
        defaultMessage: "ÚJ"
    },
    [committeeOpinion_1.Status.COMMITTEE_OPINION]: {
        id: "ktx.patient_status.short.committee_opinion",
        defaultMessage: "BV"
    },
    [committeeOpinion_1.Status.READY_FOR_COMMITTEE]: {
        id: "ktx.patient_status.short.ready_for_committee",
        defaultMessage: "BR"
    },
    [committeeOpinion_1.Status.WAITING_FOR_MEDICAL_EXAMINATION]: {
        id: "ktx.patient_status.short.waiting_for_medical_examination",
        defaultMessage: "KVV"
    },
    [committeeOpinion_1.Status.TRANSPLANTABLE]: {
        id: "ktx.patient_status.short.transplantable",
        defaultMessage: "T"
    },
    [committeeOpinion_1.Status.SUITABLE]: {
        id: "ktx.patient_status.short.suitable",
        defaultMessage: "ALS"
    },
    [committeeOpinion_1.Status.NON_TRANSPLANTABLE]: {
        id: "ktx.patient_status.short.non_transplantable",
        defaultMessage: "NT"
    },
    [committeeOpinion_1.Status.UNSUITABLE]: {
        id: "ktx.patient_status.short.unsuitable",
        defaultMessage: "ALK"
    },
    [committeeOpinion_1.Status.KTX_DONE]: {
        id: "ktx.patient_status.short.ktx_done",
        defaultMessage: "VTX"
    },
    [committeeOpinion_1.Status.EXIT]: {
        id: "ktx.patient_status.short.exit",
        defaultMessage: "EX"
    }
};
exports.longStatusMessages = {
    [committeeOpinion_1.Status.NEW]: {
        id: "ktx.patient_status.long.new",
        defaultMessage: "Új"
    },
    [committeeOpinion_1.Status.COMMITTEE_OPINION]: {
        id: "ktx.patient_status.long.committee_opinion",
        defaultMessage: "Bizottsági véleményezésre küldve"
    },
    [committeeOpinion_1.Status.READY_FOR_COMMITTEE]: {
        id: "ktx.patient_status.long.ready_for_committee",
        defaultMessage: "Bizottsági Referálásra Kész"
    },
    [committeeOpinion_1.Status.WAITING_FOR_MEDICAL_EXAMINATION]: {
        id: "ktx.patient_status.long.waiting_for_medical_examination",
        defaultMessage: "Kiegészítő Vizsgálatra Vár"
    },
    [committeeOpinion_1.Status.TRANSPLANTABLE]: {
        id: "ktx.patient_status.long.transplantable",
        defaultMessage: "Transzplantálható"
    },
    [committeeOpinion_1.Status.SUITABLE]: {
        id: "ktx.patient_status.long.suitable",
        defaultMessage: "Alkalmas"
    },
    [committeeOpinion_1.Status.NON_TRANSPLANTABLE]: {
        id: "ktx.patient_status.long.non_transplantable",
        defaultMessage: "Nem Transzplantálható"
    },
    [committeeOpinion_1.Status.UNSUITABLE]: {
        id: "ktx.patient_status.long.unsuitable",
        defaultMessage: "Alkalmatlan"
    },
    [committeeOpinion_1.Status.KTX_DONE]: {
        id: "ktx.patient_status.long.ktx_done",
        defaultMessage: "VTX megtörtént"
    },
    [committeeOpinion_1.Status.EXIT]: {
        id: "ktx.patient_status.long.exit",
        defaultMessage: "Exit"
    }
};
